import { OPTION_DISCOUNT } from "constants/discount";
import { GENDER } from "constants/gender";
import { ROLES } from "constants/roles";
import { TRACK_TYPES } from "constants/types";

export const RoleOptions = [
  { label: "Admin", value: ROLES.ADMIN },
  { label: "User", value: ROLES.USER },
];

export const GenderOptions = [
  { label: "Male", value: GENDER.MALE },
  { label: "Female", value: GENDER.FEMALE },
  { label: "Other", value: GENDER.OTHER },
];

export const TypeTrackOptions = [
  { label: "Audio", value: TRACK_TYPES.AUDIO },
  { label: "Video", value: TRACK_TYPES.VIDEO },
];

export const optionDiscount = [
  { label: OPTION_DISCOUNT.DISCOUNT10, value: OPTION_DISCOUNT.NUMBER10 },
  { label: OPTION_DISCOUNT.DISCOUNT15, value: OPTION_DISCOUNT.NUMBER15 },
  { label: OPTION_DISCOUNT.DISCOUNT20, value: OPTION_DISCOUNT.NUMBER20 },
  { label: OPTION_DISCOUNT.DISCOUNT25, value: OPTION_DISCOUNT.NUMBER25 },
  { label: OPTION_DISCOUNT.DISCOUNT30, value: OPTION_DISCOUNT.NUMBER30 },
  { label: OPTION_DISCOUNT.DISCOUNT35, value: OPTION_DISCOUNT.NUMBER35 },
  { label: OPTION_DISCOUNT.DISCOUNT40, value: OPTION_DISCOUNT.NUMBER40 },
  { label: OPTION_DISCOUNT.DISCOUNT45, value: OPTION_DISCOUNT.NUMBER45 },
  { label: OPTION_DISCOUNT.DISCOUNT50, value: OPTION_DISCOUNT.NUMBER50 },
  { label: OPTION_DISCOUNT.DISCOUNT55, value: OPTION_DISCOUNT.NUMBER55 },
  { label: OPTION_DISCOUNT.DISCOUNT60, value: OPTION_DISCOUNT.NUMBER60 },
  { label: OPTION_DISCOUNT.DISCOUNT65, value: OPTION_DISCOUNT.NUMBER65 },
  { label: OPTION_DISCOUNT.DISCOUNT70, value: OPTION_DISCOUNT.NUMBER70 },
  { label: OPTION_DISCOUNT.DISCOUNT75, value: OPTION_DISCOUNT.NUMBER75 },
];
